import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { DeprecatedFeatureChip } from 'components/Chips/DeprecatedFeatureChip'
import { Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { KNOWLEDGE_BASE_URL } from '../../constants'
import { Schema } from '../../schema'

export const NonConsentTrafficMonetizationSection = (): JSX.Element => {
  const { t: tC } = useTranslation('common')
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.prebid.nonConsentTrafficMonetization',
  })

  const ability = useAbility()
  const { control } = useFormContext<Schema>()

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        subtitleEndAdornment={
          <TextLink
            link={{
              title: tC('learnMore'),
              url: KNOWLEDGE_BASE_URL.NON_CONSENT_TRAFFIC_MONETIZATION,
            }}
          />
        }
        title={t('title')}
        titleEndAdornment={<DeprecatedFeatureChip />}
      />

      <GapBox />

      <Switch
        control={control}
        disabled={ability.cannot('update', 'GlobalSetupFeature-defaults-prebid')}
        label={t('monetizeNonConsentTraffic')}
        labelPlacement='start'
        name='monetizeNonConsentTraffic'
      />
    </Paper>
  )
}
